import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { accessFormPopupActions } from '@common-reducers/AccessFormPopupReducer';
import { contactsLabelsSelectOneObjectByQuery, labelSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { toggleChatLabelThunk } from '@common-reducers/labels-reducer/labels-thunks';
import { selectUserObject } from '@common-reducers/UserSelectors';
import { CheckCircle2 } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";

type Props = {
    waChatId: string;
    size?: number;
}

export default memo(function MarkAsDoneButton({ waChatId, size }: Props) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(selectUserObject);

    const label = useAppSelector(state => labelSelectOneObjectByQuery(state.DBLabelReducer, {
        name: 'done'
    }))

    const contactLabel = useAppSelector((state) => contactsLabelsSelectOneObjectByQuery(state.DBContactsLabelsReducer, {
        labelId: label?._id,
        waChatId
    }))

    function toggleDone(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();

        if (!authUser?._id) {
            dispatch(accessFormPopupActions.setStatus('Login'));
            return;
        }

        dispatch(toggleChatLabelThunk({
            waChatId: waChatId,
            labelId: label?._id || '',
        }))
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className={`p-1 rounded transition-colors cursor-pointer hover:text-green-600 ${contactLabel ? "text-green-600" : "text-gray-500"}`}
                        onClick={toggleDone}
                    >
                        <CheckCircle2 size={size || 18} className="currentColor" strokeWidth={2} />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>{contactLabel ? t('labels.markAsNotDone') : t('labels.markAsDone')}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
})
